export default __webpack_public_path__ + "static/media/scales.240e3e92.svg";